
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.333 2.667a.667.667 0 00-.666.667v9.333c0 .369.298.667.666.667h9.334a.667.667 0 00.666-.667V3.334a.667.667 0 00-.666-.667H3.333zm-2 .667a2 2 0 012-2h9.334a2 2 0 012 2v9.333a2 2 0 01-2 2H3.333a2 2 0 01-2-2V3.334z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.667 5.334a.333.333 0 100 .667.333.333 0 000-.667zM4 5.667a1.667 1.667 0 113.333 0 1.667 1.667 0 01-3.333 0zM10.195 6.196c.26-.26.683-.26.943 0l3.333 3.333a.667.667 0 11-.942.943L10.667 7.61l-6.862 6.862a.667.667 0 01-.943-.943l7.333-7.333z"}})])
          )
        }
      }
    